import { tabsPropsSchema } from '../component-catalog.js';
export const tabsDefinition = {
    type: 'Tabs',
    category: 'layout',
    propsSchema: tabsPropsSchema,
    isDataBacked: false,
    needsMeasuredDims: false,
    expandsVertically: true,
    description: 'Tabbed container that switches between child panels. Props: tabs (required, array of { id, label }), defaultTab?.',
};
//# sourceMappingURL=Tabs.js.map